//
// Copyright (c) 2011-2021 by Curalate, Inc.
//

import moment from 'moment-timezone';

import { ALTERNATE_TOASTS } from '@legacy-components/common/toast-notifications/toastNotificationsConstants';
import { IToastNotification } from '@legacy-components/common/toast-notifications/toastNotificationsModel';
import { pluralize } from '@utils/stringUtils';

const baseToastNotification = {
  options: {
    toastTemplate: ALTERNATE_TOASTS.NEW_TOAST,
  },
};

export const scheduleSinglePinSucceededToast = (
  scheduleTime: Date,
): IToastNotification => {
  return {
    ...baseToastNotification,
    title: 'Pin Scheduled',
    message: `Your pin has been scheduled for ${moment(scheduleTime).format(
      'LL',
    )}`,
  };
};

export const scheduleBulkPinsSucceededToast = (
  pinCount: number,
  scheduleTime: Date,
): IToastNotification => {
  return {
    ...baseToastNotification,
    title: 'Pins Scheduled',
    message: `You have successfully scheduled ${pluralize(
      pinCount,
      'pin',
    )} starting on ${moment(scheduleTime).format('LL')}`,
  };
};
